import { Box, Grid2 as Grid, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";
import { IconButton, MenuComponent } from "../..";
import { ITableMenuModel } from "../model/types";

export interface ITablePageHeaderProps {
  title?: string | ReactNode;
  onAddClick?: () => void;
  disableTablePageHeader?: boolean;
  onSettingsClick?: () => void;
  tableMenuModel?: ITableMenuModel;
}

function TablePageHeader({
  title,
  onAddClick,
  onSettingsClick,
  tableMenuModel,
  disableTablePageHeader,
}: ITablePageHeaderProps) {
  const renderTitle = () => {
    if (typeof title === "string") {
      return <Typography variant="h6">{title}</Typography>;
    }

    return title;
  };

  return (
    <Box sx={{ pb: 6 }}>
      <Box>
        <Grid
          container
          spacing={2}
          sx={{
            justifyContent: "space-between",
          }}
        >
          <Grid
            sx={{
              flex: 1,
            }}
          >
            {renderTitle()}
          </Grid>

          {(onSettingsClick || onAddClick || tableMenuModel) && (
            <Grid>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <Box
                  className={disableTablePageHeader ? "disabled" : ""}
                  sx={{
                    ["&.disabled"]: { opacity: "0.4", pointerEvents: "none" },
                  }}
                >
                  <Stack direction="row" spacing={5}>
                    {onSettingsClick && (
                      <IconButton
                        size="large"
                        color="secondary"
                        iconName="tune"
                        onClick={onSettingsClick}
                      />
                    )}
                    {onAddClick && (
                      <IconButton
                        size="large"
                        color="secondary"
                        iconName="add"
                        onClick={onAddClick}
                      />
                    )}
                    {!!tableMenuModel && (
                      <MenuComponent
                        id={tableMenuModel.uuid}
                        menuItems={tableMenuModel.menuItems}
                        iconName={tableMenuModel.iconName}
                        sx={{ [".icons"]: { width: 20, height: 20 } }}
                      />
                    )}
                  </Stack>
                </Box>
              </Box>
            </Grid>
          )}
        </Grid>
      </Box>
    </Box>
  );
}

export default TablePageHeader;
